export const globalRouter = {
    navigate: () => {}
}